import 'react-toastify/dist/ReactToastify.css';
import './style/index.scss'
import React, {Suspense} from 'react';
import ReactDOM from 'react-dom/client';
import {ThemeProvider} from "@material-tailwind/react";
import LoadingPage from "./components/general/LoadingPage";
import {BrowserRouter} from "react-router-dom";
import CustomToastContainer from "./components/general/CustomToast";
import {I18nextProvider} from "react-i18next";
import i18next from "./translations/index";
import {PATH} from "./conf";
import App from "./App";
import {QueryClientProvider} from "@tanstack/react-query";
import queryClient from "./services/configuration/queryClient";
import {SnackbarProvider, useSnackbar} from "notistack";
import {Close} from "@mui/icons-material";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
    <QueryClientProvider client={queryClient}>
        <BrowserRouter basename={PATH}>
            <ThemeProvider>
                <I18nextProvider i18n={i18next}>
                    <SnackbarProvider
                        action={snackbarKey => <SnackbarCloseButton snackbarKey={snackbarKey} />}
                        classes={{
                            containerRoot: 'snackbar-container'
                        }}
                        autoHideDuration={12000}
                        maxSnack={6}
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                    >
                        <CustomToastContainer/>
                        <Suspense fallback={<LoadingPage className={'bg-header min-h-[100vh]'} logo={true}/>}>
                            <App />
                        </Suspense>
                    </SnackbarProvider>
                </I18nextProvider>
             </ThemeProvider>
      </BrowserRouter>
    </QueryClientProvider>
);

function SnackbarCloseButton({ snackbarKey }: { snackbarKey: any }) {
    const { closeSnackbar } = useSnackbar();

    return (
        <Close
            className="mr-2 h-4 w-4 text-white cursor-pointer"
            onClick={() => closeSnackbar(snackbarKey)}
        />
    );
}
